export const PAGE_SIZE_FIELD_NAME = 'pageSize';
export const PAGE_NUMBER_FIELD_NAME = 'pageNumber';
export const API_SORT_FIELD_NAME = 'sortByDate';
export const TYPE = 'type';
export const LEVEL = 'level';
